import {
	createComment,
	createReply,
	deleteComment,
	editComment,
	getCommentReactionCounts,
	getCommentReactions,
	getCommentsList,
	getKnowledgeItemCommentImageUrl,
	registerCommentReaction,
	unregisterCommentReaction,
	updateCommentReaction
} from "client/Api/Hub/KnowledgeItems/knowledgeItemComments";
import { HubCommentSectionService } from "../../HubCommentSection/HubCommentSection";
import { doesUserHaveAccess, findUsers } from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";

export function getKnowledgeItemCommentService(
	knowledgeItemId: number
): HubCommentSectionService {
	function withKnowledgeItemId<TArgs extends unknown[], TResult>(
		callback: (knowledgeItemId: number, ...args: TArgs) => Promise<TResult>
	): (...args: TArgs) => Promise<TResult> {
		return (...args: TArgs) => callback(knowledgeItemId, ...args);
	}

	return {
		createComment: withKnowledgeItemId(createComment),
		createReply: withKnowledgeItemId(createReply),
		deleteComment: withKnowledgeItemId(deleteComment),
		editComment: withKnowledgeItemId(editComment),
		getCommentReactionCounts: withKnowledgeItemId(getCommentReactionCounts),
		getCommentReactions: withKnowledgeItemId(getCommentReactions),
		registerCommentReaction: withKnowledgeItemId(registerCommentReaction),
		unregisterCommentReaction: withKnowledgeItemId(unregisterCommentReaction),
		updateCommentReaction: withKnowledgeItemId(updateCommentReaction),
		doesUserHaveAccess: withKnowledgeItemId(doesUserHaveAccess),
		findUsers: withKnowledgeItemId(findUsers),
		getCommentsList: withKnowledgeItemId(getCommentsList),
		getCommentImageUrl: getKnowledgeItemCommentImageUrl
	};
}